export default {
  isWhitelabelConfigFresh: false,
  whitelabelConfig: undefined,
}
